import React from "react";
import { visibleQuickCreateGroups } from "../config/quickCreate";
import { useDashboardCarouselSwipe } from "../hooks/useDashboardCarouselSwipe";
import { usePermissions } from "../hooks/usePermissions";
import {
  CrewPilotNavList,
  CrewPilotNavRow,
  CrewPilotNavSectionHeader,
} from "./CrewPilotNavRow";
import { HomeSwipeAffordance } from "./DashboardPositionIndicator";

function PlusIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <circle cx="16" cy="16" r="11" stroke="currentColor" strokeWidth="1.8" />
      <path d="M16 10v12M10 16h12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

/**
 * The other face of mobile Home. One launcher, both swipe directions.
 * Actions call existing workflows; this screen does not collect the record.
 */
export function QuickCreateScreen({ onSwipe, onAction }) {
  const { can } = usePermissions();
  const { ref, style } = useDashboardCarouselSwipe({
    onNavigate: onSwipe,
  });
  const groups = visibleQuickCreateGroups(can);

  return (
    <div ref={ref} className="mode-select-screen nx-mode-screen" style={style}>
      <div style={{ padding: "22px 20px 0" }}>
        <HomeSwipeAffordance
          face="quick_create"
          onActivate={() => onSwipe?.("left")}
        />
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "var(--nx-gold)",
            marginTop: 14,
          }}
        >
          Quick Create
        </div>
        <h1
          style={{
            margin: "6px 0 0",
            fontSize: 26,
            fontWeight: 650,
            letterSpacing: "-0.03em",
            color: "var(--nx-text)",
          }}
        >
          Start something new
        </h1>
      </div>

      <div className="cp-nav-screen-body">
        {groups.length === 0 ? (
          <p className="pj-empty">Nothing to create with this account.</p>
        ) : (
          groups.map((group) => (
            <React.Fragment key={group.id}>
              <CrewPilotNavSectionHeader>{group.label}</CrewPilotNavSectionHeader>
              <CrewPilotNavList>
                {group.actions.map((action) => (
                  <CrewPilotNavRow
                    key={action.id}
                    icon={<PlusIcon />}
                    title={action.title}
                    subtitle={action.subtitle}
                    onClick={() => onAction?.(action.action)}
                  />
                ))}
              </CrewPilotNavList>
            </React.Fragment>
          ))
        )}
      </div>
    </div>
  );
}
